/**
 * @fileoverview URL Yardımcı Fonksiyonları
 *
 * Bu modül, harici link açma ve URL dönüştürme işlevlerini sağlar.
 * window.openai.openExternal API'si ile entegre çalışır.
 *
 * @module utils/url
 */

/**
 * Relative URL'i tam Emlakjet URL'ine dönüştürür.
 *
 * İlan URL'leri API'den /ilan/123456 formatında gelir.
 * Bu fonksiyon tam URL oluşturur: https://www.emlakjet.com/ilan/123456
 *
 * @param {string|null} relativeUrl - Relative URL veya tam URL
 * @returns {string|null} Tam URL veya null
 *
 * @example
 * toEmlakjetUrl("/ilan/123456")
 * // "https://www.emlakjet.com/ilan/123456"
 *
 * toEmlakjetUrl("https://www.emlakjet.com/ilan/123")
 * // "https://www.emlakjet.com/ilan/123" (değişmez)
 */
export function toEmlakjetUrl(relativeUrl) {
  if (!relativeUrl) return null;
  if (relativeUrl.startsWith("http://") || relativeUrl.startsWith("https://")) {
    return relativeUrl;
  }
  return `https://www.emlakjet.com${relativeUrl.startsWith("/") ? "" : "/"}${relativeUrl}`;
}

/**
 * Harici URL'i yeni sekmede açar.
 *
 * Önce window.openai.openExternal API'sini dener (ChatGPT içinde).
 * Yoksa standart window.open kullanır.
 *
 * @param {string|null} href - Açılacak URL
 * @returns {void}
 *
 * @example
 * // Emlakjet'te ilan aç
 * openExternal("https://www.emlakjet.com/ilan/123456")
 *
 * // Telefon araması başlat
 * openExternal("tel:+905551234567")
 */
export function openExternal(href) {
  if (!href) return;
  if (window.openai?.openExternal) {
    window.openai.openExternal({ href });
    return;
  }
  window.open(href, "_blank", "noopener,noreferrer");
}
